import React from 'react';

const Footer = () => {
  return <footer className="footer-position">Powered by ChargeZone®</footer>;
};
export default Footer;
